import style from '@magoosh/gre/pages/essay_review/style.module.scss';
import Essay from '@magoosh/gre/pages/essay_review/essay/template';
import cx from 'classnames';
import * as React from 'react';
import { WritingExample } from '@magoosh/admin/writing_examples/types';
import { useEffect } from 'react';
import { Evaluation } from '@magoosh/gre/pages/essay_review/types';
import AnnotationSidebar from '@magoosh/gre/pages/essay_review/annotation_sidebar/template';
import Modal from '@magoosh/lib/modal';
import VideoPlayer from '@magoosh/organisms/video_player';

interface Props {
  writingExample: WritingExample;
  evaluation?: Evaluation;
}
const WritingExampleDocument: React.FC<Props> = (props: Props) => {
  const [currentAnnotation, setCurrentAnnotation] = React.useState(null);
  const [mobileMode, setMobileMode] = React.useState(false);
  const evaluation = props.writingExample.evaluation;

  useEffect(() => {
    setMobileMode(window.innerWidth < 992);
  });

  const renderAnnotations = () => {
    if (mobileMode) {
      return renderAnnotationModal();
    } else {
      return (
        <div className={style.rightColumn}>
          <div>
            <AnnotationSidebar evaluation={evaluation} currentAnnotation={currentAnnotation} />
          </div>
        </div>
      );
    }
  };

  const renderAnnotationModal = () => {
    if (!currentAnnotation) {
      return null;
    }

    const highlight = props.writingExample.document.slice(
      currentAnnotation.startIndex,
      currentAnnotation.endIndex
    );
    const author = evaluation.author;

    return (
      <Modal
        show={!!currentAnnotation}
        backdrop={true}
        showCloseButton={true}
        onHide={() => setCurrentAnnotation(null)}>
        <div className={style.modalAnnotation}>
          <h3>Essay Evaluation & Commentary</h3>
          <small>
            by {author.name}
            {author.name && ', '}
            {author.description}
          </small>
          <div className={style.modalHighlight}>
            <mark>{highlight}</mark>
          </div>
          <div className={cx(style.preSpace, 'u-margin-B-l')}>{currentAnnotation.text}</div>
        </div>
      </Modal>
    );
  };

  const authorTitle = () => {
    const author = evaluation.author;
    if (author.name) {
      return `${author.name}, ${author.description}`;
    } else {
      return author.description;
    }
  };

  return (
    <div className={mobileMode ? '' : style.essayReviewBackground}>
      <div className={style.essayReviewContainer}>
        <div className={style.flexRow}>
          <div className={style.leftColumn}>
            <h1>{props.writingExample.title}</h1>
            {props.writingExample.prompt && (
              <>
                <h3>Prompt</h3>
                <p>{props.writingExample.prompt}</p>
              </>
            )}
            {props.writingExample.lesson && (
              <>
                <h3>{props.writingExample.lesson.title}</h3>
                <VideoPlayer {...props.writingExample.lesson.videoPlayerProps} />
              </>
            )}
          </div>
          <div className={style.rightColumn} />
        </div>
        <div className={style.flexRow}>
          <div className={style.leftColumn}>
            <div>
              <Essay
                onClickHighlight={setCurrentAnnotation}
                mobileMode={mobileMode}
                text={props.writingExample.document}
                evaluation={evaluation}
              />
              <h4 className={cx(style.commentaryHeader, 'u-margin-T-m u-padding-T-m')}>
                Additional Commentary
              </h4>
              {evaluation && (
                <div className={style.evaluation}>
                  <p className={style.evaluationCredit}>by {authorTitle()}</p>
                  {evaluation.text}
                </div>
              )}
            </div>
          </div>
          {evaluation && renderAnnotations()}
        </div>
      </div>
    </div>
  );
};

export default WritingExampleDocument;
